import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { getSVGImagePath } from "./SVGImagePath.js";
import { SVGIconWrapper } from "./SVGIconWrapper.js";
import { Rotation } from "../../../constants/index.js";
import { EmptyComponent } from "../EmptyComponent.js";

const SVGIconV3 = props => {
  const {
    iconName,
    width,
    height,
    rotation,
    color,
    hoverColor,
    onClick,
    dataTestId
  } = props;

  const [path, setPath] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const loadPath = async () => {
      const svgPath = await getSVGImagePath(iconName);
      if (!cancelled) {
        setPath(svgPath);
      }
    };
    if (iconName) {
      void loadPath();
    }
    return () => {
      cancelled = true;
    };
  }, [iconName]);

  if (!iconName || !path) {
    console.warn("SVGIconV3: iconName or path missing", { iconName, path }); // Debug log
    return <EmptyComponent />;
  }

  return (
    <SVGIconWrapper
      id={iconName}
      data-testid={dataTestId}
      $src={path}
      $width={width}
      $height={height}
      $rotation={rotation}
      $color={color}
      $hoverColor={hoverColor}
      onClick={onClick}
    />
  );
};

SVGIconV3.defaultProps = {
  rotation: Rotation.Default
};

SVGIconV3.propTypes = {
  iconName: PropTypes.string,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  rotation: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  onClick: PropTypes.func,
  dataTestId: PropTypes.string
};

export default React.memo(SVGIconV3);
